import {
    FormTextBox,
    FormSelect,
    FormTextArea,
    IDynamicFormRow,
} from '@src/components';
import { INPUT_CONFIG } from '@src/constants/inputConfig';
import { isValidEmail } from '@src/utilities/validation';

type SupportSchemaProps = {
    t: (key: string, options?: Record<string, any>) => string;
};

export function supportSchema({ t }: SupportSchemaProps): IDynamicFormRow[] {
    return [
        {
            label: t('forms.support.email'),
            keyName: 'email',
            inputProperties: {
                placeholder: t('forms.support.emailPlaceholder'),
                type: 'email',
            },
            Component: FormTextBox,
            className: 'w-full',
            registerOptions: {
                required: {
                    value: true,
                    message: t('errors.formErrors.required', {
                        name: t('forms.support.email'),
                    }),
                },
                validate: (email) => {
                    if (!isValidEmail(email))
                        return t('errors.formErrors.email');
                    return true;
                },
            },
        },
        {
            label: t('forms.support.category'),
            keyName: 'subject',
            inputProperties: {
                placeholder: t('forms.support.categoryPlaceholder'),
            },
            Component: FormSelect,
            className: 'w-full',
            formProps: {
                selectOptions: [
                    {
                        label: t('forms.support.categories.accountAccess'),
                        value: 'account_access',
                    },
                    {
                        label: t('forms.support.categories.orderingPurchasing'),
                        value: 'ordering_purchasing',
                    },
                    {
                        label: t('forms.support.categories.esimDelivery'),
                        value: 'esim_delivery',
                    },
                    {
                        label: t('forms.support.categories.esimActivation'),
                        value: 'esim_activation',
                    },
                    {
                        label: t('forms.support.categories.topupRelated'),
                        value: 'topup_related',
                    },
                    {
                        label: t('forms.support.categories.partnership'),
                        value: 'partnership',
                    },
                    {
                        label: t('forms.support.categories.other'),
                        value: 'other',
                    },
                ],
                allowClear: true,
                showSearch: true,
            },
            registerOptions: {
                required: {
                    value: true,
                    message: t('errors.formErrors.required', {
                        name: t('forms.support.category'),
                    }),
                },
            },
        },
        {
            label: t('forms.support.message'),
            keyName: 'body',
            Component: FormTextArea,
            className: 'w-full',
            formProps: {
                maxLength: INPUT_CONFIG.DESCRIPTION.maxLength,
                showCount: true,
                placeholder: t('forms.support.messagePlaceholder'),
            },
            registerOptions: {
                required: {
                    value: true,
                    message: t('errors.formErrors.required', {
                        name: t('forms.support.message'),
                    }),
                },

                maxLength: {
                    value: INPUT_CONFIG.DESCRIPTION.maxLength,
                    message: t('errors.formErrors.maxLength', {
                        name: t('forms.support.message'),
                        max: INPUT_CONFIG.DESCRIPTION.maxLength,
                    }),
                },
            },
        },
    ];
}
